import { IDocument, IInput } from 'app/services/api5-service/api.interface';

import { DocHelper } from 'utils/dochelper';

export interface InputControlWithValue {
  readonly control: IInput;
  readonly type: 'input';
  value: string;
}

/**
 * Check that input control meta is text input meta
 *
 * @param control - control metadata
 */
export function isTextControl(control: IInput): boolean {
  return control.$type === 'text';
}

/**
 * Map control metadata to typed object with value from doc state
 *
 * @param control - control metadata
 * @param doc - doc
 */
export function getTypeControlForText(
  control: IInput,
  doc: IDocument,
): InputControlWithValue {
  return {
    value: DocHelper.getStringValue(control.$name, doc),
    control,
    type: 'input',
  };
}
